module.exports = __webpack_public_path__ + "img/feature-optimize-icon.7d75c43f.svg";